import React from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import ClassEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ProjectGoalobjectiveEdit = ({
  projectID,
  goalID,
  objectiveID,
  objectiveEditModal,
  setObjectiveEditModal,
  setObjectiveEditState,
  objectiveEditstate,
  handleEditObjective,
  setSelectedObjective,
  editGoalObjectiveMutation,
}) => {
  const handleEdit = () => {
    const data = {
      project_id: projectID,
      goal_id: goalID,
      id: objectiveID,
      name: objectiveEditstate,
    };

    handleEditObjective(data);
    setObjectiveEditState("");
    setSelectedObjective(null);
    setObjectiveEditModal(false);
  };

  return (
    <Dialog
      open={objectiveEditModal}
      TransitionComponent={Transition}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle
        sx={{
          color: "purple",
          textTransform: "uppercase",
          fontWeight: "600",
          textDecoration: "underline",
        }}
      >
        Edit Objective
      </DialogTitle>

      {editGoalObjectiveMutation.isError && (
        <Alert variant="filled" severity="error">
          Something went wrong while editing the Objective kindly refresh and
          try again
        </Alert>
      )}

      <DialogContent>
        <Box
          sx={{
            width: 500,
            maxWidth: "100%",
            marginTop: "10px",
          }}
        >
          <CKEditor
            className="form-control"
            editor={ClassEditor}
            data={objectiveEditstate}
            onChange={(event, editor) => {
              const data = editor.getData();
              setObjectiveEditState(data);
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleEdit}
          variant="contained"
          color="secondary"
          disabled={editGoalObjectiveMutation.isLoading}
        >
          {editGoalObjectiveMutation.isLoading
            ? "Editing..."
            : "Edit Objective"}
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => setObjectiveEditModal(false)}
        >
          cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectGoalobjectiveEdit;
